import { useMutation, useQuery, useQueryClient } from "react-query";
import { CreateSeasonPlayer, SeasonPlayer } from "../models/Player";
import { useBackendMutationFunction } from "./common/useBackendMutationFunction";
import { useBackendQueryFunction } from "./common/useBackendQueryFunction";
import { UrlQuery } from "./common/useBackendUrl";

export const GetPlayersKey = "GetPlayers";

interface UseGetPlayerProps extends UrlQuery {
  id: string;
}

export function useGetPlayer(props: UseGetPlayerProps) {
  const queryFn = useBackendQueryFunction<SeasonPlayer>("/players/:id", props);

  return useQuery<SeasonPlayer>([GetPlayersKey, props], queryFn);
}

interface UseGetPlayersProps extends UrlQuery {
  seasonId: string;
}

export function useGetPlayers(props: UseGetPlayersProps) {
  const queryFn = useBackendQueryFunction<SeasonPlayer[]>(
    "/seasons/:seasonId/players",
    props
  );

  return useQuery<SeasonPlayer[]>([GetPlayersKey, props], queryFn);
}

interface UseGetPlayersofTeamProps extends UrlQuery {
  teamId: string;
}
export function useGetPlayersofTeam(props: UseGetPlayersofTeamProps) {
  const queryFn = useBackendQueryFunction<SeasonPlayer[]>(
    "/teams/:teamId/players",
    props
  );

  return useQuery<SeasonPlayer[]>([GetPlayersKey, props], queryFn);
}

interface UseDeletePlayerProps extends UrlQuery {
  playerId: string;
}
export function useDeletePlayer(props: UseDeletePlayerProps) {
  const mutationFn = useBackendMutationFunction<SeasonPlayer, void>(
    "/players/:playerId",
    "DELETE",
    props
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetPlayersKey);
    },
  });
}

export function usePostPlayer() {
  const mutationFn = useBackendMutationFunction<
    SeasonPlayer,
    CreateSeasonPlayer
  >("/players", "POST");
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetPlayersKey);
    },
  });
}

export function usePatchPlayer() {
  const mutationFn = useBackendMutationFunction<SeasonPlayer, SeasonPlayer>(
    "/players",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetPlayersKey);
    },
  });
}
